
/* injects from baggage-loader */
var Template = require('./template.js');

import { Component } from "react";
import { connect } from "react-redux";
import {PrintBookingTicket} from "../../../../dev/actions/terminal";
import { UIMixin } from "../../../mixins/uiMixin";
import PropTypes from "prop-types";
import { createSelector } from "reselect";
import { BetslipClear } from "../../../actions/betslip";

class BookingInfo extends Component {
    constructor (props) {
        super(props);
        this.printBookingTicket = this.printBookingTicket.bind(this);
    }

    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }

    printBookingTicket () {
        let bets, events, price, posWin, bookId, typeId, amount, systemMinCount;
        bets = {...this.props.betEvents};
        events = Object.keys(bets);
        bookId = this.props.bookNum;
        price = this.props.price;
        posWin = this.props.posWin;
        typeId = this.props.typeId;
        amount = parseInt(this.props.amount);
        systemMinCount = this.props.systemMinCount;
        return () => {
            this.props.closePopup()();
            this.props.dispatch(PrintBookingTicket(
                JSON.stringify({
                    bookId,
                    price,
                    posWin,
                    typeId,
                    amount,
                    systemMinCount,
                    selection_list: events.map(item => (bets[item]))
                })
            ));
            this.props.dispatch(BetslipClear());
        };
    }
}

const mapStateToProps = (_) => {
    return createSelector(
        [
            state => state.terminal.isAdminLoggedIn
        ],
        (isAdminLoggedIn) => {
            return {isAdminLoggedIn};
        }
    );
};

BookingInfo.propTypes = {
    closePopup: PropTypes.func,
    betEvents: PropTypes.object,
    bookNum: PropTypes.number,
    price: PropTypes.number,
    posWin: PropTypes.number,
    typeId: PropTypes.number,
    amount: PropTypes.string,
    systemMinCount: PropTypes.number
};

export default connect(mapStateToProps)(UIMixin({Component: BookingInfo}));